import { render, staticRenderFns } from "./buy-books-details.vue?vue&type=template&id=543d99ec"
import script from "./buy-books-details.vue?vue&type=script&lang=js"
export * from "./buy-books-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports